import {Regions} from "./../model/Region"
import {UniversityBranches} from "./../model/UniversityBranch"
import {Specialities} from "./../model/Speciality"
import {Demand, DemandList} from "../model/Demand"
import {Divisions} from "../model/Division"

import {SheetData} from "./../Excel/export"
import {getCompany, getSpeciality, RowData} from "./../model/utils/utils"
import {User} from "../model/User";
import {
    Columns, demandColumnToYear, entranceColumns, makeEmptyRow, makeSpecialityData,
    makeUniversityData,
    Rows,
    specialityColumns,
    specialityMerges,
    universityColumns,
    universityMerges,
    makeSheet,
    border,
} from "./common";

const columnsOrder = [
    ...specialityColumns,
    Columns.isOpk,
    ...entranceColumns,
    Columns.entranceFactorDemand,
    Columns.entranceFactorTarget,
    ...universityColumns,
]

type Data = {
    demand: DemandList
    divisions: Divisions
    regions: Regions
    specialities: Specialities
    universityBranches: UniversityBranches
    meta: {
        company: string
        user: User
    }
}

const composeData = ({
    demand,
    divisions,
    regions,
    specialities,
    universityBranches,
}: Data): RowData[] => {
    let rawResult: RowData[] = []

    demand.map(({
        id,
        companyId,
        courseOfStudyName,
        entranceFactorDemand,
        entranceFactorTarget,
        specialityId,
        regionId,
        universityBranchId,
        entranceByYear,
        nationalProjectName,
        englishLevelName,
        languageName,
    }: Demand) => {
        const {
            isOpk,
        } = getCompany(divisions, companyId)

        const {
            bachelorSpecialityId,
        } = getSpeciality(specialities, specialityId)

        const row = makeEmptyRow(columnsOrder, {
            ...makeSpecialityData({
                id,
                courseOfStudyName,
                divisions,
                companyId,
                specialities,
                specialityId,
                nationalProjectName,
                englishLevelName,
                languageName,
            }),
            ...makeUniversityData({
                regions,
                regionId,
                universityBranches,
                universityBranchId,
            }),
            [Columns.isOpk]: (isOpk/* && specialitiesOpk.has(specialityId)*/) ? "Да" : "Нет",
            [Columns.entranceFactorDemand]: entranceFactorDemand,
            [Columns.entranceFactorTarget]: entranceFactorTarget,
            ...entranceColumns.reduce((row, column) => ({...row, [column]: entranceByYear[demandColumnToYear[column]] || ""}), {}),
        })

        if (entranceColumns.some(column => !!row[column])) {
            rawResult = rawResult.concat([row])
        }

        if (bachelorSpecialityId) {
            const row = makeEmptyRow(columnsOrder, {
                ...makeSpecialityData({
                    id: id + "." + specialityId,
                    courseOfStudyName,
                    divisions,
                    companyId,
                    specialities,
                    specialityId: bachelorSpecialityId,
                    nationalProjectName,
                    englishLevelName,
                    languageName,
                }),
                ...makeUniversityData({
                    regions,
                    regionId,
                    universityBranches,
                    universityBranchId,
                }),
                [Columns.isOpk]: (isOpk/* && specialitiesOpk.has(specialityId)*/) ? "Да" : "Нет",
                [Columns.entranceFactorDemand]: entranceFactorDemand,
                [Columns.entranceFactorTarget]: entranceFactorTarget,
                ...entranceColumns.reduce((row, column) => ({...row, [column]: entranceByYear[demandColumnToYear[column] + 4] || ""}), {}),
            })

            if (entranceColumns.some(column => !!row[column])) {
                rawResult = rawResult.concat([row])
            }
        }
    })

    return rawResult;
}

export const entranceWs = (data: Data): SheetData => makeSheet({
    sheetTitle: "КЦП",
    title1: "КЦП в образовательные организации.",
    company: data.meta.company,
    fullName: data.meta.user.executor.fullName,
    columnsOrder,
    heading1Row: {
        [entranceColumns[0]]: {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "top"}},    v: "Прогноз"},
        [Columns.isOpk]: {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "center"}}, v: "Является ли ОПК"},
    },
    merges: [
        ...specialityMerges,

        [entranceColumns[0], Rows.Heading1, entranceColumns[entranceColumns.length - 1], Rows.Heading2],
        [Columns.isOpk,                Rows.Heading1, Columns.isOpk,                Rows.Heading3],
        [Columns.entranceFactorDemand, Rows.Heading1, Columns.entranceFactorDemand, Rows.Heading3],
        [Columns.entranceFactorTarget, Rows.Heading1, Columns.entranceFactorTarget, Rows.Heading3],

        ...universityMerges,
    ],
    data: composeData(data),
    specialities: data.specialities,
})